import React, { useEffect, useState, useContext, useCallback } from 'react';
import { AppContext } from '../contexts/appContext';
import { checkIfUserSignedIn } from '../helpers/general';
import SunbitAPI from '../services/SunbitApi';
import StorageService from '../services/Storage';
import { LoaderActionContext } from '../contexts/loaderContext';

enum AuthState {
  AUTHENTICATED,
  UNAUTHENTICATED,
  AUTHENTICATING,
}

export default ({ children }) => {
  const [authState, setAuthState] = useState(AuthState.AUTHENTICATING);
  const loaderContext = React.useContext(LoaderActionContext);

  const { setCredentials, cleanUserData } = useContext(AppContext);

  useEffect(() => {
    const init = async () => {
      loaderContext.setLoader(true);

      try {
        const userDetails = await checkIfUserSignedIn();

        setCredentials(userDetails);
        SunbitAPI.setToken(userDetails.userToken);

        setAuthState(AuthState.AUTHENTICATED);
      } catch (e) {
        setAuthState(AuthState.UNAUTHENTICATED);
      } finally {
        loaderContext.setLoader(false);
      }
    };

    init();
    // eslint-disable-next-line
  }, []);

  const logout = useCallback(() => {
    SunbitAPI.removeToken();

    cleanUserData();

    StorageService.remove('userToken');
    StorageService.remove('userName');

    setAuthState(AuthState.UNAUTHENTICATED);
  }, [cleanUserData]);
  const login = useCallback(
    (userName, userToken) => {
      SunbitAPI.setToken(userToken);

      setCredentials({ userName, userToken });

      StorageService.set('userToken', userToken);
      StorageService.set('userName', userName);

      setAuthState(AuthState.AUTHENTICATED);
    },
    [setCredentials]
  );

  if (authState !== AuthState.AUTHENTICATING)
    return children({ login, logout, isLoggedIn: authState === AuthState.AUTHENTICATED });

  return null;
};
